module.exports = __webpack_public_path__ + "img/calendar-week-fill.d9c4ba6d.svg";